<template>
  <section
    v-side-navigation-only-count
    class="
      scrollerWrapper flex h-svh flex-col justify-between overflow-hidden bg-theme-200 px-container
      lg:px-container-desktop
      md:px-container-lg
    "
  >
    <UiLable class="mb-36 mt-22">
      {{ data.title }}
    </UiLable>
    <div
      ref="scroller"
      v-animate-children-in-from-left
      class="relative mb-[20svh] flex w-fit flex-row text-dark"
    >
      <template
        v-for="fact in data.facts"
        :key="fact.id"
      >
        <!-- FULL -->
        <div
          v-if="fact.size?.value === 'full'"
          class="mr-28 flex h-full w-56 min-w-fit flex-col gap-8 border-b border-current"
        >
          <div class="size-20">
            <AppImage
              v-if="fact?.icon"
              :src="fact.icon"
              :alt="useMapAltText(fact.icon)"
              class="object-contain"
            />
          </div>

          <AnimateNumber
            :is-running="isInViewport"
            class="text-display-3xl"
            :number="Number(fact.number)"
            :unit="fact.unit?.value"
          />
          <div class="pb-8 pr-4">
            <h3 class="text-body-xl-fat">
              {{ fact.title }}
            </h3>
            <p class="text-body-xl">
              {{ fact.text }}
            </p>
          </div>
        </div>
        <!-- SPLIT -->
        <div
          v-else
          class="mr-26 grid grid-rows-2 gap-16"
        >
          <div class="border-b border-current">
            <AnimateNumber
              :is-running="isInViewport"
              class="text-display-2xl"
              :number="Number(fact.number)"
              :unit="fact.unit?.value"
            />
            <h3 class="text-heading-md font-semibold">
              {{ fact.title }}
            </h3>
          </div>
          <div class="min-w-52 border-b border-current">
            <AnimateNumber
              :is-running="isInViewport"
              class="text-display-2xl"
              :number="Number(fact?.number_two)"
              :unit="fact?.unit_two?.value"
            />
            <h3 class="text-heading-md font-semibold">
              {{ fact?.title_two }}
            </h3>
          </div>
        </div>
      </template>
      <div class="flex min-h-full shrink-0 flex-col justify-end">
        <AppButton
          v-if="data.link"
          :to="data.link"
          variant="outlined-dark"
          class="w-max"
        >
          {{ data.link_text }}
        </AppButton>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import type { ComponentsBrBrFactsFragment } from '#gql'

defineProps<{
  data: Enforce<ComponentsBrBrFactsFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const scroller = useTemplateRef('scroller')
const isInViewport = useElementVisibility(scroller)

let scrollTriggerInstance: ScrollTrigger | null = null
onMounted(() => {
  nextTick(() => {
    function getScrollAmount() {
      const scrollerWidth = scroller.value?.scrollWidth
      return -(scrollerWidth - window.innerWidth + 500)
    }

    const tween = gsap.to(scroller.value, {
      x: getScrollAmount,
      duration: 3,
      ease: 'none',
    })

    scrollTriggerInstance = ScrollTrigger.create({
      trigger: '.scrollerWrapper ',
      start: 'top 0%',
      end: () => `+=${getScrollAmount() * -1}`,
      pin: true,

      animation: tween,
      scrub: 1,
      invalidateOnRefresh: true,
      // markers: true,
    })
  })
})

onUnmounted(() => {
  scrollTriggerInstance?.kill()
})
</script>
